// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3W3nl","info":"UpdateTermsInfo_info__2KJfV"};